<template>
    <div class="p-0 pl-1 m-0" :class="{'col-12': $window.isSP, 'col-2': $window.isPC}">
        <div v-if="$window.isSP">
            <span class="pt-3" style="float:left;"><h3>交通費管理</h3></span>
            <button class="btn mt-2 btn-outline-dark" style="float:right;" @click.stop="clickShowMenu">
                <i class="fa" :class="{'fa-chevron-circle-right': !showMenu, 'fa-chevron-circle-left': showMenu}">メニュー</i>
            </button>
        </div>
        <transition>
            <div @click.stop v-show="($window.isPC) || showMenu" :class="{'accordion': $window.isSm || $window.isXs, 'open': showMenu}">
                <nav>
                    <ul class="nav nav-pills flex-column">
                        <li class="nav-item pt-2 pb-2">
                            <h3>交通費管理</h3>
                        </li>
                    </ul>
                    <ul class="nav nav-pills flex-column">
                        <li class="nav-item">
                            <a class="nav-link active" href="/admin/kotsuhi/top">
                                <i class="fa fa-users mr-1"></i>交通費一覧
                                <span v-if="unapprovedCount > 0" class="badge badge-danger">
                                    <span data-toggle="tooltip" data-placement="top" data-html="true" :title="'未承認'">
                                        {{unapprovedCount}}
                                    </span>
                                </span>
                                <span v-if="unpaidCount > 0" class="badge text-danger" style="background:yellow">
                                    <span data-toggle="tooltip" data-placement="top" data-html="true" :title="'未精算'">
                                        {{unpaidCount}}
                                    </span>
                                </span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </transition>
    </div>
</template>

<style scoped>
.accordion {
  box-shadow: 0px 0px 10px;
  position: absolute;
  left: -1000px;
  padding: 20px;
  background-color: rgb(255, 255, 255);
  z-index: 100;
}

.accordion.open {
  left: -15px;
  padding-right: 100px;
  border-radius: 0px 0px 60px;
}

.v-enter-active,
.v-leave-active {
  transition: left 0.5s, right 0.5s;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>

<script>
import KotsuhiAPI from '../../../api/kotsuhi-api'
import Vue from "vue";
import WindowStatePlugin from "../../../util/WindowStatePlugin";

Vue.use(WindowStatePlugin);

export default {
  name: 'kotsuhi-menu',
  data() {
    return {
      unapprovedCount: 0,
      unpaidCount: 0,
      showMenu: false,
    };
  },
  mounted() {
    this.getUnapprovedCount()
    this.getUnpaidCount()

    // 画面他の部分タッチで非表示（タブレット・スマホ時）
    $(document).click(function() {　
        if((this.$window.isSm || this.$window.isXs) && this.showMenu == true){
            this.showMenu = false
        }
    }.bind(this));
  },
  methods: {
    // 未承認件数取得
    getUnapprovedCount () {
        KotsuhiAPI.getUnapprovedKotsuhiList()
            .then(res => {
                this.unapprovedCount = res.length
            })
            .catch(err => {
                console.error(err)
            })
    },
    // 未精算件数取得
    getUnpaidCount () {
        KotsuhiAPI.getUnpaidKotsuhiList()
            .then(res => {
                this.unpaidCount = res.length
            })
            .catch(err => {
                console.error(err)
            })
    },
    // メニュー表示/非表示（スマホ）
    clickShowMenu() {
      this.showMenu = !this.showMenu;
    }
  },
  filters: {
  }
}
</script>




// WEBPACK FOOTER //
// src/assets/js/components/admin/kotsuhi/KotsuhiMenu.vue